module.exports = __webpack_public_path__ + "static/media/blog2.c7f45df6.jpg";